import React from 'react';

/**
 * NavigationControls Component
 * Provides Next, Back, Skip, and Finish buttons for walkthrough navigation
 */
const NavigationControls = ({
  onNext,
  onPrevious,
  onSkip,
  stepIndex,
  totalSteps
}) => {
  const isFirstStep = stepIndex === 0;
  const isLastStep = stepIndex === totalSteps - 1;

  const handleKeyDown = (e, action) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };

  return (
    <div className="walkthrough-nav-controls">
      {/* Skip Button */}
      <button
        className="walkthrough-skip-button"
        onClick={onSkip}
        onKeyDown={(e) => handleKeyDown(e, onSkip)}
        aria-label="Skip walkthrough"
      >
        Skip tour
      </button>

      {/* Navigation Buttons */}
      <div className="walkthrough-nav-controls-right">
        {/* Back Button */}
        <button
          className="walkthrough-back-button"
          onClick={onPrevious}
          onKeyDown={(e) => handleKeyDown(e, onPrevious)}
          disabled={isFirstStep}
          aria-label="Previous step"
        >
          Back
        </button>

        {/* Next/Finish Button */}
        <button
          className="walkthrough-next-button"
          onClick={onNext}
          onKeyDown={(e) => handleKeyDown(e, onNext)}
          aria-label={isLastStep ? 'Finish walkthrough' : 'Next step'}
        >
          {isLastStep ? 'Get Started' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default NavigationControls;
